import { TemplatePage } from './types';

const imageFacebookCoverPage: TemplatePage = {
  header: {
    color: '#83DEF3',
    icon: 'images/video-templates/facebook-cover.jpg',
    title: 'Free Facebook Cover Templates',
    title_meta: 'Free Editable Facebook Cover Templates',
    description_meta:
      'Create cover images that attract attention with Wave.video’s collection of editable Facebook cover templates.',
    description:
      'Create cover images that attract attention with our collection of editable Facebook cover templates. Highlight your ' +
      'brand’s message, promote an event, or showcase your products with the help of an appealing Facebook cover image.'
  },
  footer: {
    type: 'image',
    showCustomizeVideo: false,
    category: 'Facebook Cover',
    description:
      'With Wave.video’s wide collection of easy-to-customize and free Facebook cover templates, you will be able to create ' +
      'memorable images for your social media page in a few minutes. No need to clutter up your computer with heavy software ' +
      'and files — you will only need access to the internet and a web browser to succeed in all of your creative endeavors. ' +
      'Just select a template that you prefer and effortlessly customize it to your taste. Reach your marketing goals with ' +
      'Wave.video free Facebook cover templates!'
  },
  content: [
    {
      type: 'templates',
      title: 'Free Facebook Cover Templates',
      search: {
        category: '/images/facebook cover'
      }
    }
  ]
};

export default imageFacebookCoverPage;
